import React from 'react';
import PropTypes from 'prop-types';
import { Auth0Provider } from '@auth0/auth0-react';

const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;

const AuthProvider = ({ children }) => (
  <Auth0Provider
    domain={AUTH0_DOMAIN}
    clientId={AUTH0_CLIENT_ID}
    redirectUri={window.location.origin}
    audience={AUTH0_AUDIENCE}
    cacheLocation="localstorage"
  >
    {children}
  </Auth0Provider>
);
AuthProvider.propTypes = {
  children: PropTypes.object,
};

export default AuthProvider;
